// extracted by mini-css-extract-plugin
export default {"ActivityTypesFilterLabelColor":"style_ActivityTypesFilterLabelColor__qCgw3","ActivityTypesFilterLabel":"style_ActivityTypesFilterLabel__3z74+"};